import React, { useEffect, useState } from "react";
import "./Projects.css";
import Aos from "aos";
import "aos/dist/aos.css";

const Projects = () => {
  useEffect(() => {
    Aos.init({ duration: 2500 });
  }, []);
  const [show, setShow] = React.useState(false);

  return (
    <section className="Projects" data-aos="fade-up">
      <h4>Other Noteworthy Projects</h4>
      <a>View my projects</a>

      <div className="flow">
        <div className="box">
          <div className="box_ins">
            <header>
              <div>
                <div>
                  <i className="far fa-folder-open"></i>
                </div>
                <div>
                  <a href="https://github.com/neqts/reactWebsite">
                    <i className="fab fa-github"></i>
                  </a>

                  <a href="https://nervous-hermann-738ec9.netlify.app/">
                    {" "}
                    <i className="fas fa-external-link-alt"></i>
                  </a>
                </div>
              </div>
              <h5>Website with finances</h5>
              <div>
                <p>
                  A modern finacnces website with interesting layout and
                  futuristic effects
                </p>
              </div>
            </header>

            <footer>
              <ul>
                <li>JavaScript</li>
                <li>React</li>
                <li>CSS</li>
                <li>HTML</li>
              </ul>
            </footer>
          </div>
        </div>
        <div className="box">
          <div className="box_ins">
            <header>
              <div>
                <div>
                  <i className="far fa-folder-open"></i>
                </div>
                <div>
                  <a href="https://github.com/neqts/guessColor">
                    <i className="fab fa-github"></i>
                  </a>

                  <a href="https://neqts.github.io/guessColor/">
                    {" "}
                    <i className="fas fa-external-link-alt"></i>
                  </a>
                </div>
              </div>
              <h5>Guessing color game</h5>
              <div>
                <p>
                  A color guessing game based on Red Green Blue color system
                </p>
              </div>
            </header>

            <footer>
              <ul>
                <li>JavaScript</li>
                <li>CSS</li>
                <li>HTML</li>
                <li>SASS</li>
              </ul>
            </footer>
          </div>
        </div>

        <div className="box">
          <div className="box_ins">
            <header>
              <div>
                <div>
                  <i className="far fa-folder-open"></i>
                </div>
                <div>
                  <a href="https://github.com/neqts/validatorJS">
                    <i className="fab fa-github"></i>
                  </a>

                  <a href="https://neqts.github.io/validatorJS/">
                    {" "}
                    <i className="fas fa-external-link-alt"></i>
                  </a>
                </div>
              </div>
              <h5>Validator </h5>
              <div>
                <p>
                  This program validates the document with the changed syntax
                </p>
              </div>
            </header>

            <footer>
              <ul>
                <li>JavaScript</li>
                <li>CSS</li>
                <li>HTML</li>
              </ul>
            </footer>
          </div>
        </div>

        <div className="box">
          <div className="box_ins">
            <header>
              <div>
                <div>
                  <i className="far fa-folder-open"></i>
                </div>
                <div>
                  <a href="https://github.com/neqts/aspa/tree/master">
                    <i className="fab fa-github"></i>
                  </a>

                  <a href="https://neqts.github.io/aspa/">
                    {" "}
                    <i className="fas fa-external-link-alt"></i>
                  </a>
                </div>
              </div>
              <h5>ASPA website</h5>
              <div>
                <p>
                  Product page with a modernist finish for which I used SASS
                  styling.
                </p>
              </div>
            </header>

            <footer>
              <ul>
                <li>JavaScript</li>
                <li>Sass</li>
                <li>React</li>
                <li>CSS</li>
                <li>HTML</li>
              </ul>
            </footer>
          </div>
        </div>

        <div className="box">
          <div className="box_ins">
            <header>
              <div>
                <div>
                  <i className="far fa-folder-open"></i>
                </div>
                <div>
                  <a href="https://github.com/neqts/reactWeb">
                    <i className="fab fa-github"></i>
                  </a>

                  <a href="https://gifted-kepler-7403da.netlify.app/">
                    {" "}
                    <i className="fas fa-external-link-alt"></i>
                  </a>
                </div>
              </div>
              <h5>Travel website</h5>
              <div>
                <p>
                  Travel website with interesting effects based on React Js Html
                  Css
                </p>
              </div>
            </header>

            <footer>
              <ul>
                <li>JavaScript</li>
                <li>React</li>
                <li>CSS</li>
                <li>HTML</li>
              </ul>
            </footer>
          </div>
        </div>

        <div className="box">
          <div className="box_ins">
            <header>
              <div>
                <div>
                  <i className="far fa-folder-open"></i>
                </div>
                <div>
                  <a href="https://github.com/neqts/todoListUpdate">
                    <i className="fab fa-github"></i>
                  </a>

                  <a href="https://neqts.github.io/todoListUpdate/">
                    {" "}
                    <i className="fas fa-external-link-alt"></i>
                  </a>
                </div>
              </div>
              <h5>To do List</h5>
              <div>
                <p>
                  To do list is a list where you can save your daily tasks,App
                  with pop up menu
                </p>
              </div>
            </header>

            <footer>
              <ul>
                <li>JavaScript</li>

                <li>CSS</li>
                <li>HTML</li>
              </ul>
            </footer>
          </div>
        </div>
        {show ? (
          <div data-aos="fade-up">
            <div className="box">
              <div className="box_ins">
                <header>
                  <div>
                    <div>
                      <i className="far fa-folder-open"></i>
                    </div>
                    <div>
                      <a href="https://github.com/neqts/guessNumber">
                        <i className="fab fa-github"></i>
                      </a>

                      <a href="https://neqts.github.io/guessNumber/">
                        {" "}
                        <i className="fas fa-external-link-alt"></i>
                      </a>
                    </div>
                  </div>
                  <h5>Guess the number game</h5>
                  <div>
                    <p>A guessing the number game with hints and score</p>
                  </div>
                </header>

                <footer>
                  <ul>
                    <li>JavaScript</li>

                    <li>CSS</li>
                    <li>HTML</li>
                  </ul>
                </footer>
              </div>
            </div>

            <div className="box">
              <div className="box_ins">
                <header>
                  <div>
                    <div>
                      <i className="far fa-folder-open"></i>
                    </div>
                    <div>
                      <a href="https://github.com/neqts/printJson">
                        <i className="fab fa-github"></i>
                      </a>

                      <a href="https://neqts.github.io/printJson/">
                        {" "}
                        <i className="fas fa-external-link-alt"></i>
                      </a>
                    </div>
                  </div>
                  <h5>Converter Text/Json</h5>
                  <div>
                    <p>
                      The program allows you to edit the text and allows you to
                      download and save the file in the text / json format
                    </p>
                  </div>
                </header>

                <footer>
                  <ul>
                    <li>VanilaJS</li>

                    <li>HTML</li>
                  </ul>
                </footer>
              </div>
            </div>

            <div className="box">
              <div className="box_ins">
                <header>
                  <div>
                    <div>
                      <i className="far fa-folder-open"></i>
                    </div>
                    <div>
                      <a href="https://github.com/neqts/BankWeb">
                        <i className="fab fa-github"></i>
                      </a>

                      <a href="https://hungry-kepler-a21168.netlify.app/">
                        {" "}
                        <i className="fas fa-external-link-alt"></i>
                      </a>
                    </div>
                  </div>
                  <h5>Bank Web </h5>
                  <div>
                    <p>Simple bank website with video and hamburger menu</p>
                  </div>
                </header>

                <footer>
                  <ul>
                    <li>JavaScript</li>
                    <li>CSS</li>
                    <li>React</li>
                    <li>HTML</li>
                  </ul>
                </footer>
              </div>
            </div>

            <div className="box">
              <div className="box_ins">
                <header>
                  <div>
                    <div>
                      <i className="far fa-folder-open"></i>
                    </div>
                    <div>
                      <a href="https://github.com/neqts/rollDice">
                        <i className="fab fa-github"></i>
                      </a>

                      <a href="https://neqts.github.io/rollDice/">
                        {" "}
                        <i className="fas fa-external-link-alt"></i>
                      </a>
                    </div>
                  </div>
                  <h5>Roll dice game</h5>
                  <div>
                    <p>
                      The first person to score 100 points by throwing the dice
                    </p>
                  </div>
                </header>

                <footer>
                  <ul>
                    <li>JavaScript</li>

                    <li>CSS</li>
                    <li>HTML</li>
                  </ul>
                </footer>
              </div>
            </div>

            <div className="box">
              <div className="box_ins">
                <header>
                  <div>
                    <div>
                      <i className="far fa-folder-open"></i>
                    </div>
                    <div>
                      <a href="https://github.com/neqts/todoListUpdate">
                        <i className="fab fa-github"></i>
                      </a>

                      <a href="https://github.com/neqts/converterFarenCelsiusJs">
                        {" "}
                        <i className="fas fa-external-link-alt"></i>
                      </a>
                    </div>
                  </div>
                  <h5>Celsius Converter</h5>
                  <div>
                    <p>
                      converter that converts degrees Celsius to degrees
                      Fahrenheit
                    </p>
                  </div>
                </header>

                <footer>
                  <ul>
                    <li>JavaScript</li>

                    <li>CSS</li>
                    <li>HTML</li>
                  </ul>
                </footer>
              </div>
            </div>

            <div className="box">
              <div className="box_ins">
                <header>
                  <div>
                    <div>
                      <i className="far fa-folder-open"></i>
                    </div>
                    <div>
                      <a href="https://github.com/neqts/webTechnologyProject">
                        <i className="fab fa-github"></i>
                      </a>

                      <a href="https://neqts.github.io/webTechnologyProject/">
                        {" "}
                        <i className="fas fa-external-link-alt"></i>
                      </a>
                    </div>
                  </div>
                  <h5>Web desinger</h5>
                  <div>
                    <p>Web site developer page, studies project</p>
                  </div>
                </header>

                <footer>
                  <ul>
                    <li>JavaScript</li>

                    <li>CSS</li>
                    <li>HTML</li>
                  </ul>
                </footer>
              </div>
            </div>

            <div className="box">
              <div className="box_ins">
                <header>
                  <div>
                    <div>
                      <i className="far fa-folder-open"></i>
                    </div>
                    <div>
                      <a href="https://github.com/neqts/TomaszTopor">
                        <i className="fab fa-github"></i>
                      </a>

                      <a href="https://neqts.github.io/TomaszTopor">
                        {" "}
                        <i className="fas fa-external-link-alt"></i>
                      </a>
                    </div>
                  </div>
                  <h5>Previous portfolio</h5>
                  <div>
                    <p>
                      Passes the previous portfolio in which I used bootstrap
                      and UI/UX effects
                    </p>
                  </div>
                </header>

                <footer>
                  <ul>
                    <li>JavaScript</li>

                    <li>CSS</li>
                    <li>HTML</li>
                  </ul>
                </footer>
              </div>
            </div>
          </div>
        ) : (
          true
        )}
      </div>

      <div className="extand">
        <button onClick={() => setShow(!show)}>More</button>
      </div>
    </section>
  );
};

export default Projects;
